export function SpaceBoot() {
  return (
    <div className="crm-space-boot" role="status" aria-label="Préparation de votre espace">
      <div className="crm-boot-scene" aria-hidden>
        <div className="crm-boot-fiche">
          <span className="crm-boot-avatar" />
          <span className="crm-boot-line crm-boot-line-a" />
          <span className="crm-boot-line crm-boot-line-b" />
          <span className="crm-boot-pill" />
        </div>
        <div className="crm-boot-week">
          {DAYS.map((day) => (
            <div className="crm-boot-day" key={day} style={{ animationDelay: `${0.15 + day * 0.08}s` }}>
              <span className="crm-boot-dayhead" />
              <span className="crm-boot-card" style={{ ["--h" as string]: day === 1 ? "2.35rem" : "1.55rem", animationDelay: `${0.35 + day * 0.12}s` }} />
              <span className="crm-boot-card" style={{ ["--h" as string]: "1.15rem", animationDelay: `${0.55 + day * 0.12}s` }} />
            </div>
          ))}
        </div>
        <span className="crm-boot-mail">
          <MailIcon />
        </span>
      </div>
      <p className="crm-space-boot-title">Préparation de votre espace</p>
    </div>
  );
}

const DAYS = [0, 1, 2];

function MailIcon() {
  return (
    <svg viewBox="0 0 24 16" className="h-full w-full" fill="none">
      <rect x="0.75" y="0.75" width="22.5" height="14.5" rx="2.5" fill="currentColor" fillOpacity="0.12" stroke="currentColor" strokeWidth="1.4" />
      <path d="M1.5 2.2 12 9.2 22.5 2.2" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  );
}
